import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Login0 = ({ isOpen, onClose }) => {
  const [phone, setPhone] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isSignUp, setIsSignUp] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [formData, setFormData] = useState({
    name: "",
    email_id: "",
    mobile_number: "",
    user_type: "Customer",
    admin_auto_id: sessionStorage.getItem("admin_auto_id"),
    country_code: "IN-91",
    country_name: "India",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
  });
  const [loginBannerImage, setLoginBannerImage] = useState(
    "https://placehold.co/400x400"
  );
  const navigate = useNavigate();
  const appName = sessionStorage.getItem("appName"); 

  const [themeIconColor,setThemeIconColor]=useState("#000000");
  const [themeColor,setThemeColor]=useState("#000000"); 
  const [webFont, setWebFont] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {
    const fullOtp = otp.join("");
    if (fullOtp.length === 4 && otp.every((digit) => digit !== "") && !isVerifying) {
      handleVerifyOTP();
    }
  }, [otp]);
  

  

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []); 


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;
  
    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));
  
    return `rgb(${r}, ${g}, ${b})`;
  }
  
  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;
  
    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));
  
    return `rgb(${r}, ${g}, ${b})`;
  }

  useEffect(() => {
    if (!isSignUp || !formData.city || !formData.address) return;

    const fetchCoordinates = async () => {
      const address = `${formData.address}, ${formData.city}, ${formData.country_name}`;
      const apiKey = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";

      try {
        const response = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json",
          { params: { address, key: apiKey } }
        );

        if (response.data.status === "OK") {
          const location = response.data.results[0].geometry.location;
          setFormData((prev) => ({
            ...prev,
            latitude: location.lat,
            longitude: location.lng,
          }));
        } else {
          console.error("Geocoding API Error:", response.data.status);
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchCoordinates();
  }, [isSignUp, formData.city, formData.address]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      try {
        const parsedStyle = JSON.parse(storedStyle);
        if (parsedStyle?.login_banner_image) {
          const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/business_details/${parsedStyle.login_banner_image}`;
          setLoginBannerImage(imageUrl);
        }
      } catch (error) {
        console.error("Error parsing UIStyle from sessionStorage:", error);
      }
    }
  }, []);

  if (!isOpen) return null;

  const handleSendOTP = async () => {
    if (phone.length !== 10) {
      setMessage({ text: "Please enter a valid 10-digit phone number.", type: "error" });
      return;
    }

    try {
      const apiURL = isSignUp
        ? `${process.env.REACT_APP_API_BASE_URL}/send_registration_otp`
        : `${process.env.REACT_APP_API_BASE_URL}/send_login_otp`;

      const payload = isSignUp
        ? {
            mobile_number: phone,
            user_type: formData.user_type,
            admin_auto_id: formData.admin_auto_id,
          }
        : {
            mobile_number: phone,
            user_type: formData.user_type,
            country_code: formData.country_code,
            admin_auto_id: formData.admin_auto_id,
          };

      const response = await axios.post(apiURL, payload);

      if (response.data.status === "1") {
        setOtpSent(true);
        setMessage({ text: response.data.msg || "OTP sent successfully.", type: "success" });
      } else {
        setMessage({ text: response.data.msg || "Error sending OTP.", type: "error" });
      }
    } catch (error) {
      setMessage({
        text: "Error sending OTP: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    }
  };

  const handleVerifyOTP = async () => {
    setIsVerifying(true);
    try {
      const apiURL = isSignUp
        ? `${process.env.REACT_APP_API_BASE_URL}/verify_registration_otp`
        : `${process.env.REACT_APP_API_BASE_URL}/login`;

      const payload = isSignUp
        ? {
            mobile_number: phone,
            otp: otp.join(""),
            user_type: formData.user_type,
            admin_auto_id: formData.admin_auto_id,
          }
        : {
            mobile_number: phone,
            user_type: formData.user_type,
            country_code: formData.country_code,
            admin_auto_id: formData.admin_auto_id,
            otp: otp.join(""),
          };

      const response = await axios.post(apiURL, payload);

      if (response.data.status === "1") {
        sessionStorage.setItem("accessToken", response.data.user_id);
        if (isSignUp) {
          await handleUserRegistration();
        } else {
          setMessage({ text: response.data.msg || "Login successful!", type: "success" });
          setTimeout(() => {
            onClose();
            window.location.reload();
          }, 3000);
        }
      } else {
        setMessage({ text: response.data.msg || "Error verifying OTP.", type: "error" });
      }
    } catch (error) {
      setMessage({
        text: "Error verifying OTP: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    } finally {
      setIsVerifying(false);
    }
    
  };

  const handleUserRegistration = async () => {
    if (!isSignUp) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/user_registration`,
        { ...formData, mobile_number: phone }
      );

      if (response.data.status === "1") {
        const userAutoId = response.data.user_auto_id;
        sessionStorage.setItem("accessToken", userAutoId);
        setMessage({ text: response.data.msg || "Registration successful!", type: "success" });
        setTimeout(() => {
          onClose();
          window.location.reload();
        }, 3000);
      } else {
        setMessage({ text: response.data.msg || "Error during registration.", type: "error" });
      }
    } catch (error) {
      setMessage({
        text: "Error during registration: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setPhone(value);
    }
  };

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${webFont}`}>
      <div className="relative flex flex-col bg-white rounded-lg shadow-2xl w-96">
        <button
          onClick={onClose}
          className="absolute text-gray-500 top-2 right-2 hover:text-gray-900"
        >
          <FaTimes size={24} />
        </button>

        <img
          src={loginBannerImage}
          alt="Login"
          className="object-cover w-full h-48 rounded-t-lg"
        />

        {message.text && (
          <div
            className={`text-center p-2 text-sm ${
              message.type === "error" ? "text-red-500" : "text-green-500"
            }`}
          >
            {message.text}
          </div>
        )}

        <div className="flex-1 p-6 text-black">
          <h4 className="mb-4 text-xl">{isSignUp ? "Sign Up" : "Sign In"}</h4>

          {isSignUp && (
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="text-sm">Full Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full text-xs transition duration-300 border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
                />
              </div>
              <div>
                <label className="text-sm">Email</label>
                <input
                  type="email"
                  name="email_id"
                  placeholder="Email"
                  value={formData.email_id}
                  onChange={handleChange}
                  className="w-full text-xs transition duration-300 border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
                />
              </div>
              <div>
                <label className="text-sm">City</label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                  className="w-full text-xs transition duration-300 border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
                />
              </div>
              <div>
                <label className="text-sm">Address</label>
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full text-xs transition duration-300 border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
                />
              </div>
            </div>
          )}

          <div className="flex items-center mb-4">
            <div className="w-1/4">
              <label className="text-sm">Country</label>
              <input
                type="text"
                value="🇮🇳 +91"
                readOnly
                className="w-full transition duration-300 bg-transparent border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
              />
            </div>

            <div className="w-3/4 ml-2">
              <label className="text-sm">Phone Number</label>
              <input
                type="text"
                placeholder="Enter phone number"
                value={phone}
                onChange={handlePhoneChange}
                className="w-full transition duration-300 border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
              />
            </div>
          </div>

          {!otpSent ? (
            <>
              <div className="flex items-center justify-center gap-2">
                <button
                  onClick={handleSendOTP}
                  className="w-full px-4 py-2 text-white transition duration-300 rounded-md "
                  style={{ backgroundColor: themeColor }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                    e.currentTarget.style.backgroundColor = darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = themeColor;
                  }}
                >
                  Send OTP
                </button>
              </div>
              <p className="mt-2 text-xs text-right cursor-pointer">
                {isSignUp ? "Existing user " : "New user "}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSignUp(!isSignUp);
                  }}
                  className="underline"
                  style={{ color: themeColor }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                    e.currentTarget.style.color = darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = themeColor;
                  }}
                >
                  {isSignUp ? "Sign In" : "Sign Up"}
                </Link>
              </p>
            </>
          ) : (
            <>
              <label className="text-sm">Enter OTP</label>
              <div className="flex justify-between mb-4">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    className="w-10 text-center transition duration-300 border-b-2 border-gray-300 focus:outline-none focus:border-gray-500"
                  />
                ))}
              </div>

              <button
                onClick={handleVerifyOTP}
                disabled={isVerifying}
                className="w-full px-4 py-2 text-white transition duration-300 rounded-md "
                style={{ backgroundColor: themeColor }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                    e.currentTarget.style.backgroundColor = darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = themeColor;
                  }}
              >
                {isVerifying ? "Verifying..." : "Verify OTP"}
              </button>
            </>
          )}
        </div>

        <div
          className={`text-center text-xs text-gray-500 p-4 border-t ${
            isSignUp ? "mt-2" : "mt-20"
          }`}
        >
          By continuing, you agree to {appName}
          <br />
          <Link
            to="/termsandcondition"
            onClick={() => onClose()}
            className="underline"
            style={{ color: themeColor }}
                onMouseEnter={(e) => {
                  const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                  e.currentTarget.style.color = darkenedColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = themeColor;
                }}
          >
            Terms & Conditions
          </Link>{" "}
          and
          <Link
            to="/privacyandpolicy"
            onClick={() => onClose()}
            className="ml-1 underline"
            style={{ color: themeColor }}
                onMouseEnter={(e) => {
                  const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                  e.currentTarget.style.color = darkenedColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = themeColor;
                }}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login0;